const profile = {
    name: 'Nome',
    avatar: 'Avatar',
    givenName: 'Nome',
    familyName: 'Cognome',
    middleName: 'Secondo nome',
    fullname: 'Nome completo',
    nickname: 'Soprannome',
    preferredUsername: 'Nome utente preferito',
    profile: 'Profilo',
    website: 'Sito web',
    gender: 'Genere',
    birthdate: 'Data di nascita',
    zoneinfo: 'Fuso orario',
    locale: 'Lingua',
    address: {
        formatted: 'Indirizzo',
        streetAddress: 'Indirizzo',
        locality: 'Città',
        region: 'Stato/Provincia',
        postalCode: 'CAP',
        country: 'Paese',
    },
    gender_options: {
        female: 'Femmina',
        male: 'Maschio',
        prefer_not_to_say: 'Preferisco non dire',
    },
};
export default Object.freeze(profile);
